module.exports = __webpack_public_path__ + "img/NORMCORE.3d08f578.jpg";